export const getItems = state => state.detail.data.detail;
export const getErrorMessage = state => state.detail.errorMessage;
export const getIsFetching = state => state.detail.isFetching;
export const getTotalPages = state => state.detail.data.page.total || 0;
export const getPage = state => state.detail.data.page.current || 0;
export const getTotalRow = state => state.detail.data.page.totalRow || 0;
export const getSelectedItem = state => state.detail.data.detail[state.detail.selected] || state.detail.data.detail;
